import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { SERVICE_TYPE_PATH } from '../../../../config/paths';
import ServiceTypeDeleteButton from './ServiceTypeDeleteButton';

const ServiceTypeToolbar = ({ serviceTypeId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${SERVICE_TYPE_PATH}/${serviceTypeId}/edit`} />{' '}
      <ServiceTypeDeleteButton serviceTypeId={serviceTypeId} />
    </div>
  </ButtonToolbar>
);

ServiceTypeToolbar.propTypes = {
  serviceTypeId: PropTypes.number.isRequired,
};

export default ServiceTypeToolbar;